
import { ExternalLink } from 'lucide-react';
import Modal from '../../../components/base/Modal';
import Button from '../../../components/base/Button';
import { Source } from '../../../types';

interface SourceModalProps {
  isOpen: boolean;
  onClose: () => void;
  sources: Source[];
  gameName: string;
}

export default function SourceModal({ isOpen, onClose, sources, gameName }: SourceModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`${gameName} - 出典`}
      size="md"
    >
      <div className="space-y-4">
        <p className="text-sm text-gray-600">
          この回答は以下の資料を参照しています：
        </p>
        
        <div className="space-y-3">
          {sources.map((source) => (
            <div key={source.id} className="border border-gray-200 rounded-lg p-4">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h4 className="font-medium text-gray-900">{source.name}</h4>
                  <p className="text-sm text-gray-500 mt-1">
                    {source.type === 'pdf' ? 'PDF文書' : 'ウェブページ'}
                    {source.page && ` - ${source.page}`}
                  </p>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => window.open(source.ref, '_blank')}
                  className="ml-4"
                >
                  <ExternalLink className="h-4 w-4 mr-1" />
                  閲覧
                </Button>
              </div>
            </div>
          ))}
        </div>
        
        <div className="pt-4 border-t border-gray-200">
          <p className="text-xs text-gray-500">
            ※ 外部リンクは新しいタブで開きます
          </p>
        </div>
      </div>
    </Modal>
  );
}
